module.exports = __webpack_public_path__ + "media/payments/resub-d395aef0.png";